import type { ValidationError } from './types'
import type { Studienparameter } from '@/types/studyTypes'

export function validateStudienparameter(d: Studienparameter): ValidationError[] {
  const errors: ValidationError[] = []

  if (!d.studientypContainer.studienzentren?.length)
    errors.push({
      field: 'studientypContainer.studienzentren',
      message: 'Bitte mindestens eine Option wählen.',
    })

  if (!d.studientypContainer.studientyp?.length)
    errors.push({
      field: 'studientypContainer.studientyp',
      message: 'Bitte mindestens einen Studientyp wählen.',
    })

  // Conditional: register study needs registerVerwendung
  if (
    d.studientypContainer.registerstudie &&
    !d.studientypContainer.registerVerwendung
  )
    errors.push({
      field: 'studientypContainer.registerVerwendung',
      message: 'Bitte Registerverwendung angeben.',
    })

  // Conditional: bestehendesBefuellen needs register details
  if (d.studientypContainer.registerVerwendung === 'bestehendesBefuellen') {
    if (!d.studientypContainer.bestehendesRegister?.typ)
      errors.push({
        field: 'studientypContainer.bestehendesRegister.typ',
        message: 'Bitte Registertyp wählen.',
      })
    if (!d.studientypContainer.bestehendesRegister?.name?.trim())
      errors.push({
        field: 'studientypContainer.bestehendesRegister.name',
        message: 'Registername ist ein Pflichtfeld.',
      })
  }

  if (!d.studienaufbau)
    errors.push({ field: 'studienaufbau', message: 'Bitte Studienaufbau wählen.' })

  // Conditional: prospektiv + no consent needs reason
  if (
    d.studientypContainer.studientyp?.includes('prospektiv') &&
    !d.einwilligung.einwilligungLiegtVor
  ) {
    if (!d.einwilligung.begruendungKeineEinwilligung?.trim())
      errors.push({
        field: 'einwilligung.begruendungKeineEinwilligung',
        message: 'Begründung für fehlende Einwilligung ist erforderlich.',
      })
  }

  // Conditional: consent present needs type
  if (d.einwilligung.einwilligungLiegtVor && !d.einwilligung.einwilligungsTyp)
    errors.push({
      field: 'einwilligung.einwilligungsTyp',
      message: 'Bitte Einwilligungstyp wählen.',
    })

  // Ethikvotum
  if (d.ethikVotum.ethikVotumStatus === 'liegtVor' && !d.ethikVotum.ethikVotumNummer?.trim())
    errors.push({
      field: 'ethikVotum.ethikVotumNummer',
      message: 'Votumnummer ist ein Pflichtfeld.',
    })

  if (!d.forschungszweck?.trim())
    errors.push({ field: 'forschungszweck', message: 'Forschungszweck ist ein Pflichtfeld.' })

  return errors
}
